import React from 'react';
import ContentLoader from 'react-content-loader';

const Loader = ({ width = '100%', height = 'auto' }) => (
  <div style={{ maxWidth: '577px', margin: '0 auto' }}>
    <ContentLoader
      speed={2}
      style={{ width, height }}
      primarycolor="#f3f3f3"
      secondarycolor="#ecebeb"
    >
      <rect x="0" y="40" rx="6" ry="6" width="100%" height="20" />
      <rect x="0" y="70" rx="6" ry="6" width="50%" height="20" />
      <rect x="25%" y="110" rx="6" ry="6" width="35%" height="40" />
    </ContentLoader>
  </div>
);

export default Loader;
